var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicleParked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_765_26696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_765_26696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.25V2.75H9.75C11 2.75 12.0625 3.1875 12.9375 4.0625C13.8125 4.9375 14.25 6 14.25 7.25C14.25 8.5 13.8125 9.5625 12.9375 10.4375C12.0625 11.3125 11 11.75 9.75 11.75H7.5V16.25H4.5ZM7.5 8.75H9.9C10.3125 8.75 10.6657 8.603 10.9597 8.309C11.2532 8.0155 11.4 7.6625 11.4 7.25C11.4 6.8375 11.2532 6.48425 10.9597 6.19025C10.6657 5.89675 10.3125 5.75 9.9 5.75H7.5V8.75Z",
    fill: "#595959"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleParked);
export default __webpack_public_path__ + "static/media/vehicle-parked.fa850b474b130c4ffe30cee96c5f3567.svg";
export { ForwardRef as ReactComponent };